export const RECRUITING_CONTEXT = 'Recruiting';
